/**
 * Interrupt your function when it is repeatedly called.
 * @param routine Funciton* generator of logic you want to allow to be interrupted
 * @returns
 */
export const interruptable = routine => {
    let current = undefined;
    return async (...params) => {
        if (current) {
            const old = current;
            current = undefined;
            old.return(undefined);
        }
        current = routine(...params);
        //processing loop
        let step = current.next();
        while (!step.done) {
            try {
                step = current.next(await step.value);
            }
            catch (error) {
                if (process.env.NODE_ENV == 'development') {
                    console.error('[@growmark/coroutine]:', error);
                }
                //if there was an error then we rethrow it inside the generator
                step = current.throw(error);
            }
        }
        //return
        if (!(step === null || step === void 0 ? void 0 : step.value)) {
            return undefined;
        }
        else {
            return step.value;
        }
    };
};
//# sourceMappingURL=interruptable.js.map